import styled from 'styled-components';

import { size } from '../../layout/helpers';
import { Foldout } from '../Foldout/wrapper';

export const openButtonSize = 4;

export const Wrapper = styled.div`
  position: relative;

  ${Foldout} {
    margin-top: ${size(-0.5)};
  }
`;
